import crypto from 'crypto-js'

/** 获取md5 */
export function getMd5(pw) {
  return crypto.MD5(pw).toString()
}
